/**
 * Function to get the icon path
 * @param key - icon name
 * @param iconsData - icons data
 * @returns - icon path
 */
export default function getIcon(key: string, iconsData?: any) {
    try {
        if (!iconsData) return `/icons/${key}.svg`;
        return iconsData[key] ? `${iconsData[key]}` : `/icons/${key}.svg`;
    } catch (err) {
        console.error("Error getting icon", err);
        return `/icons/${key}.svg`;
    }
}
